import { Navigate, Outlet } from "react-router-dom";
import { EnumPathRutas, EnumPerfil } from "../../../Utils/Enumeradores/ComunEnum";
import useLogin from "../Hooks/useLogin";

export default function ValidarConfiguracion({ children }) {
	const { usuario } = useLogin();
	const esInspectorFiscal =
		usuario?.perfilContexto?.id === EnumPerfil.InspectorFiscal;

	if (esInspectorFiscal) {
		return <Navigate to={EnumPathRutas.Configuracion} replace />;
	}

	return children || <Outlet />;
}
